import { PublicClientApplication } from '@azure/msal-browser'

import { cache, system } from 'auth/index'

const AUTHORITY_DOMAIN = process.env?.REACT_APP_AUTHORITY_DOMAIN ?? ''
const DOMAIN = process.env?.REACT_APP_DOMAIN ?? ''

const signUpSignIn = process.env?.REACT_APP_SIGNUP_SIGNIN ?? ''
const forgotPassword = process.env?.REACT_APP_RESET_PASSWORD ?? ''
const editProfile = process.env?.REACT_APP_EDIT_PROFILE ?? ''

export const b2cPolicies = {
  names: {
    signUpSignIn: signUpSignIn,
    forgotPassword: forgotPassword,
    editProfile: editProfile,
  },
  authorities: {
    signUpSignIn: {
      authority: `https://${AUTHORITY_DOMAIN}/${DOMAIN}.onmicrosoft.com/${signUpSignIn}`,
    },
    forgotPassword: {
      authority: `https://${AUTHORITY_DOMAIN}/${DOMAIN}.onmicrosoft.com/${forgotPassword}`,
    },
    editProfile: {
      authority: `https://${AUTHORITY_DOMAIN}/${DOMAIN}.onmicrosoft.com/${editProfile}`,
    },
  },
  authorityDomain: AUTHORITY_DOMAIN,
}

const Config = {
  auth: {
    clientId: process.env?.REACT_APP_CLIENT_ID ?? '', // This is the ONLY mandatory field that you need to supply.
    authority: b2cPolicies.authorities.signUpSignIn.authority, // Choose SUSI as your default authority.
    knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
    redirectUri: process.env?.REACT_APP_REDIRECT_URL ?? '',
    postLogoutRedirectUri: process.env?.REACT_APP_LOGOUT_URL ?? '',
    navigateToLoginRequestUrl: false,
  },
  cache,
  system,
}

export const b2cInstance = new PublicClientApplication(Config)
